import axios from "./interceptor"

export const SaleAttributionService = {
  getPendingSaleAttributions({clientSlug, campaignSlug, page, from, to, contractNumber}) {
    const url =`/api/clients/${clientSlug}/campaigns/${campaignSlug}/sale_attributions/index_pending`
    const params = { page }
    if (from) params.from = from
    if (to) params.to = to
    if (contractNumber) params['extra_fields[contractnumber]'] = contractNumber
    return axios({
      method: 'get',
      url: url,
      params
    });
  },
  updateSaleAttribution({clientSlug, campaignSlug, id, userId}) {
    const url = `/api/clients/${clientSlug}/campaigns/${campaignSlug}/sale_attributions/${id}`
    return axios({
      method: "put",
      url: url,
      data: {
        sale: {
          user_id: userId
        }
      }
    });
  },
  getCompletedSaleAttributions({clientSlug, campaignSlug, page, from, to, contractNumber}) {
    const url = `/api/clients/${clientSlug}/campaigns/${campaignSlug}/sale_attributions/index_completed`
    const params = { page }
    if (from) params.from = from
    if (to) params.to = to
    if (contractNumber) params['extra_fields[contractnumber]'] = contractNumber
    return axios({
      method: 'get',
      url: url,
      params
    });
  }
}
